const ErrorPage: React.FC = () => {
  return (
    <div className="error-screen">
      Error
    </div>
  );
};

export default ErrorPage;
